// VIETNAM
export const locale = {
  lang: 'vi',
  data: {
    TRANSLATOR: {
      SELECT: 'Lựa chọn ngôn ngữ',
    },
    MENU: {
      NEW: 'Thêm mới',
      ACTIONS: 'Thao tác',
      CREATE_POST: 'Thêm mới bài viết',
      PAGES: 'Trang',
      FEATURES: 'Tính năng',
      APPS: 'Ứng dụng',
      DASHBOARD: 'Trang chủ',
      SAMPLE: 'Sample',
      CHART: 'Biểu đồ',
      CONTENT_MANAGEMENT: 'Quản trị nội dung',
      EVENT: 'Quản lý sự kiện',
      INSTRUCTION: 'Quản lý hướng dẫn sử dụng',
      MENU: 'Quản lý menu',
      MENU_PERMISSION: 'Phân quyền menu',
      WIDGET: 'Quản lý khối thông tin',
      WIDGET_PERMISSION: 'Phân quyền khối thông tin',
      SYSTEM_MANAGEMENT: 'Quản trị hệ thống',
      GROUP_USER: 'Nhóm người dùng',
      ORGANIZATION: 'Quản lý cấp đơn vị',
      ROLE: 'Quản lý nhóm người dùng',
      USER: 'Quản lý người dùng',
      PERMISSION: 'Xem thông tin quản lý quyền',
      REPORT_MANAGEMENT: 'Quản lý thư mục báo cáo',
      REPORT: 'Quản lý báo cáo',
      REPORT_PERMISSION: 'Phân quyền báo cáo',
      FOLDER_REPORT_PERMISSION: 'Phân quyền thư mục báo cáo'
    },
    AUTH: {
      GENERAL: {
        OR: 'Hoặc',
        SUBMIT_BUTTON: 'Gửi',
        NO_ACCOUNT: 'Chưa có tài khoản?',
        SIGNUP_BUTTON: 'Đăng ký',
        FORGOT_BUTTON: 'Quên mật khẩu',
        BACK_BUTTON: 'Quay lại',
        PRIVACY: 'Riêng tư',
        LEGAL: 'Hợp pháp',
        CONTACT: 'Liên hệ',
      },
      LOGIN: {
        TITLE: 'Tài khoản đăng nhập',
        BUTTON: 'Đăng nhập',
      },
      FORGOT: {
        TITLE: 'Quên mật khẩu?',
        DESC: 'Nhập email để lấy lại mật khẩu.',
        SUCCESS: 'Tài khoản đã khôi phục mật khẩu thành công.'
      },
      REGISTER: {
        TITLE: 'Đăng ký',
        DESC: 'Nhập thông tin để thiết lập tài khoản.',
        SUCCESS: 'Tài khoản đã được thiết lập thành công.'
      },
      INPUT: {
        EMAIL: 'Email',
        FULLNAME: 'Họ tên',
        PASSWORD: 'Mật khẩu',
        CONFIRM_PASSWORD: 'Xác nhận mật khẩu',
        USERNAME: 'Tên đăng nhập'
      },
      VALIDATION: {
        INVALID: '{{name}} không hợp lệ',
        REQUIRED: '{{name}} bắt buộc',
        MIN_LENGTH: '{{name}} độ dài tối thiểu {{min}}',
        AGREEMENT_REQUIRED: 'Đồng ý điều khoản và điều kiện.',
        NOT_FOUND: 'Yêu cầu {{name}} không tìm thấy',
        INVALID_LOGIN: 'Thông tin đăng nhập không chính xác',
        REQUIRED_FIELD: 'Trường bắt buộc',
        MIN_LENGTH_FIELD: 'Độ dài tối thiểu:',
        MAX_LENGTH_FIELD: 'Độ dài giới hạn:',
        INVALID_FIELD: 'Trường không hợp lệ',
        MAX_LENGTH_FIELD_SEARCH: 'Tìm kiếm giới hạn'
      }
    },
    CONTENT_MANAGEMENT: {
      COMMON: {
        SELECTED_RECORDS_COUNT: 'Số dòng đã chọn: ',
        ALL: 'Tất cả',
        ACTIVE: 'Hiển thị',
        INACTIVE: 'Ngừng Hiển thị',
        FILTER: 'Lọc',
        BY_STATUS: 'Theo trạng thái',
        SEARCH: 'Tìm kiếm',
        IN_ALL_FIELDS: 'Tất cả các trường',
        CANCEL: 'Hủy bỏ',
        CREATE: 'Thêm mới',
        EDIT: 'Chỉnh sửa',
        DELETE: 'Xóa',
        SAVE: 'Lưu',
        VALIDATION_CHARACTER: ' ký tự'
      },
      MENU: {
        MENU: 'Menu',
        MENU_LIST: 'DANH SÁCH MENU',
        NEW_MENU: 'Thêm mới',
        SEARCH: {
          TITLE: 'Nhập tên menu',
          NAME: 'Nhập tên menu',
          DESCRIPTION: 'Nhập mô tả',
          STATUS: 'Chọn trạng thái'
        },
        DELETE_MENU_SIMPLE: {
          TITLE: 'Xóa menu',
          DESCRIPTION: 'Bạn có thực sự muốn xóa?',
          WAIT_DESCRIPTION: 'Menu đang xóa...',
          MESSAGE: 'Menu đã được xóa'
        },
        DELETE_MENU_MULTY: {
          TITLE: 'Xóa menu',
          DESCRIPTION: 'Bạn có thực sự muốn xóa?',
          WAIT_DESCRIPTION: 'Menu đang xóa...',
          MESSAGE: 'Menu đã được xóa'
        },
        UPDATE_STATUS: {
          TITLE: 'Trạng thái đã được cập nhật',
          MESSAGE: 'Trạng thái đã được cập nhật thành công'
        },
        EDIT: {
          UPDATE_MESSAGE: 'Menu đã được cập nhật',
          ADD_MESSAGE: 'Menu đã được tạo'
        },
        GRANT_PERMISSION: {
          ASSIGN_ROLE: 'Gán vai trò',
          ASSIGN_GROUP: 'Gán nhóm người dùng',
          REMOVE_ROLE: ' Bỏ gán vai trò'
        },
        FILTER_STATUS: {
          TITLE: 'Lọc theo trạng thái',
          ACTIVE: 'Hiển thị',
          INACTIVE: 'Không hiển thị'
        },
        MODEL: {
          ID: 'Id',
          TITLE: 'Tên menu',
          DESCRIPTION: 'Mô tả',
          STATUS: 'Trạng thái',
          PAGE: 'Đường dẫn',
          ICON: 'Biểu tượng',
          PARENT_ID: 'Menu cha',
          CREATED_DATE: 'Ngày tạo',
          ACTION: 'Thao tác',
          APP: 'Ứng dụng',
          PERMISSIONS: 'Quyền chức năng'
        },
        BUTTON: {
          ADD: 'Thêm',
          EDIT: 'Sửa',
          DELETE: 'Xóa'
        },
        PLACE_HOLDER: {
          TITLE: 'Nhập tên menu',
          ICON: 'Nhập link icon',
          DESCRIPTION: 'Nhập mô tả',
          EDIT_MENU: 'Sửa menu',
          PARENT: 'Chọn menu cha',
          URL: 'Chọn đường dẫn',
          APP: 'Chọn ứng dụng',
          CHOOSE_ICON: 'Chọn biểu tượng',
          ORDER: 'Nhập thứ tự sắp xếp'
        },
        VALIDATION: {
          TITLE_REQUIRED: 'Tên menu bắt buộc',
          TITLE_ALLOW: 'Tên menu hợp lệ',
          TITLE_MINLENGTH: 'Tên menu tối thiểu ',
          TITLE_MAXLENGTH: 'Tên menu giới hạn ',
          PAGE_REQUIRED: 'Đường dẫn bắt buộc',
          PAGE_ALLOW: 'Đường dẫn hợp lệ',
          ICON_REQUIRED: 'Biểu tượng bắt buộc',
          APP_REQUIRED: 'Ứng dụng bắt buộc',
          APP_ALLOW: 'Ứng dụng hợp lệ',
          ICON_ALLOW: 'Biểu tượng hợp lệ',
          DESCRIPTION_REQUIRED: 'Mô tả bắt buộc',
          DESCRIPTION_ALLOW: 'Mô tả hợp lệ',
          DESCRIPTION_MINLENGTH: 'Mô tả tối thiểu ',
          DESCRIPTION_MAXLENGTH: 'Mô tả giới hạn ',
          ORDER_NUMBER_ALLOW: 'Thứ tự sắp xếp hợp lệ',
          ORDER_NUMBER_REQUIRED: 'Thứ tự sắp xếp bắt buộc',
          ORDER_NUMBER_MINLENGTH: 'Thứ tự sắp xếp tối thiểu',
          ORDER_NUMBER_MAXLENGTH: 'Thứ tự sắp xếp giới hạn',
        }
      },
      MENU_PERMISSION: {
        MENU_PERMISSION: 'DANH SÁCH PHÂN QUYỀN MENU',
        SEARCH: {
          TITLE: 'Nhập tên vai trò',
        },
        PLACEHOLDER: {
          ROLE: 'Vai trò',
          USER: 'Người dùng',
          INPUT_USERNAME: 'Nhập tên đăng nhập',
          DELETE_PERMISSION: 'Xóa phân quyền',
          CHOOSE_USER: 'người dùng được chọn',
        },
        MODAL: {
          ADD_USER_TITLE: 'Danh sách người dùng được phân quyền vào Menu',
          ADD_ROLE_TITLE: 'Danh sách nhóm người dùng được phân quyền vào Menu'
        },
        MODEL: {
          STT: 'STT',
          ROLE: 'Vai trò',
          GROUP: 'Nhóm người dùng'
        }
      },
      AUTH: {
        GENERAL: {
          OR: 'Hoặc',
          SUBMIT_BUTTON: 'Gửi',
          NO_ACCOUNT: 'Chưa có tài khoản?',
          SIGNUP_BUTTON: 'Đăng ký',
          FORGOT_BUTTON: 'Quên mật khẩu',
          BACK_BUTTON: 'Quay lại',
          PRIVACY: 'Riêng tư',
          LEGAL: 'Hợp pháp',
          CONTACT: 'Liên hệ',
        },
        DELETE_MENU_MULTY: {
          TITLE: 'Xóa menu',
          DESCRIPTION: 'Bạn có thực sự muốn xóa?',
          WAIT_DESCRIPTION: 'Menu đang xóa...',
          MESSAGE: 'Menu đã được xóa'
        },
        UPDATE_STATUS: {
          TITLE: 'Trạng thái đã được cập nhật',
          MESSAGE: 'Trạng thái đã được cập nhật thành công'
        },
        EDIT: {
          UPDATE_MESSAGE: 'Menu đã được cập nhật',
          ADD_MESSAGE: 'Menu đã được tạo'
        },
        FILTER_STATUS: {
          TITLE: 'Lọc theo trạng thái',
          ACTIVE: 'Hiển thị',
          INACTIVE: 'Ngừng Hiển thị'
        },
        MODEL: {
          ID: 'Id',
          TITLE: 'Menu',
          DESCRIPTION: 'Mô tả',
          STATUS: 'Trạng thái',
          PAGE: 'Đường dẫn',
          CREATED_DATE: 'Ngày tạo',
          ACTION: 'Thao tác'
        },
        VALIDATION: {
          TITLE_REQUIRED: 'Tiêu đề bắt buộc',
          TITLE_ALLOW: 'Tiêu đề hợp lệ',
          TITLE_MINLENGTH: 'Tiêu đề tối thiểu ',
          TITLE_MAXLENGTH: 'Tiêu đề giới hạn ',
          DESCRIPTION_REQUIRED: 'Mô tả bắt buộc',
          DESCRIPTION_ALLOW: 'Mô tả hợp lệ',
          DESCRIPTION_MINLENGTH: 'Mô tả tối thiểu ',
          DESCRIPTION_MAXLENGTH: 'Mô tả giới hạn ',
        }
      },
      INSTRUCTION: {
        INSTRUCTION: 'Hướng dẫn sử dụng',
        INSTRUCTION_LIST: 'DANH SÁCH HƯỚNG DẪN SỬ DỤNG',
        NEW_INSTRUCTION: 'Thêm mới',
        SEARCH: {
          TITLE: 'Nhập tên hướng dẫn sử dụng'
        },
        DELETE_INSTRUCTION_SIMPLE: {
          TITLE: 'Xóa hướng dẫn sử dụng',
          DESCRIPTION: 'Bạn có thực sự muốn xóa?',
          WAIT_DESCRIPTION: 'Hướng dẫn sử dụng đang xóa...',
          MESSAGE: 'Hướng dẫn sử dụng đã được xóa'
        },
        DELETE_INSTRUCTION_MULTY: {
          TITLE: 'Xóa hướng dẫn sử dụng',
          DESCRIPTION: 'Bạn có thực sự muốn xóa?',
          WAIT_DESCRIPTION: 'Hướng dẫn sử dụng đang xóa...',
          MESSAGE: 'Hướng dẫn sử dụng đã được xóa'
        },
        UPDATE_STATUS: {
          TITLE: 'Trạng thái đã được cập nhật',
          MESSAGE: 'Trạng thái đã được cập nhật thành công'
        },
        EDIT: {
          UPDATE_MESSAGE: 'Hướng dẫn sử dụng đã được cập nhật',
          ADD_MESSAGE: 'Hướng dẫn sử dụng đã được tạo'
        },
        FILTER_STATUS: {
          TITLE: 'Lọc theo trạng thái',
          ACTIVE: 'Hiển thị',
          INACTIVE: 'Không hiển thị'
        },
        MODEL: {
          NAME: 'Tên hướng dẫn sử dụng',
          DESCRIPTION: 'Mô tả',
          STATUS: 'Trạng thái',
          FILE: 'Chi tiết',
          ACTION: 'Thao tác'
        },
        PLACE_HOLDER: {
          NAME: 'Nhập tên hướng dẫn sử dụng',
          DESCRIPTION: 'Nhập mô tả',
          FILE: 'Tải lên file HDSD',
          EDIT_INSTRUCTION: 'Cập nhật HDSD',
          DOWNLOAD_INSTRUCTION: 'Tải HDSD',
          DELETE_INSTRUCTION: 'Xóa HDSD',
        }
      },
      EVENT: {
        NAME: 'Sự kiện',
        LIST: 'DANH SÁCH SỰ KIỆN',
        NEW: 'Thêm mới',
        SEARCH: {
          TITLE: 'Nhập tên sự kiện'
        },
        DELETE_SIMPLE: {
          TITLE: 'Xóa sự kiện',
          DESCRIPTION: 'Bạn có thực sự muốn xóa?',
          WAIT_DESCRIPTION: 'Sự kiện đang xóa...',
          MESSAGE: 'Sự kiện đã được xóa'
        },
        DELETE_MULTY: {
          TITLE: 'Xóa sự kiện',
          DESCRIPTION: 'Bạn có thực sự muốn xóa?',
          WAIT_DESCRIPTION: 'Sự kiện đang xóa...',
          MESSAGE: 'Sự kiện đã được xóa'
        },
        MODEL: {
          name: 'Tên sự kiện',
          description: 'Mô tả sự kiện',
          shortDescription: 'Mô tả ngắn',
          createdDate: 'Ngày tạo',
          status: 'Trạng thái',
          timeEvent: 'Ngày diễn ra sự kiện',
          timeEnd: 'Ngày kết thúc sự kiện'
        },
        PLACEHOLDER: {
          NAME: 'Nhập tên sự kiện',
          DESCRIPTION: 'Nhập mô tả',
          SHORT_DESCRIPTION: 'Nhập mô tả ngắn',
          CREATED_DATE: 'Nhập ngày tạo',
          STATUS: 'Chọn trạng thái',
          TIME_EVENT: 'Nhập thời gian diễn ra sự kiện',
          TIME_END: 'Nhập thời kết thúc ra sự kiện',
          EDIT_EVENT: 'Sửa sự kiện',
          DELETE_EVENT: 'Xóa sự kiện',
        },
        VALIDATION: {
          name: 'Tên sự kiện bắt buộc',
          description: 'Mô tả sự kiện bắt buộc',
          shortDescription: 'Mô tả ngắn bắt buộc',
          createdDate: 'Ngày tạo bắt buộc',
          status: 'Trạng thái bắt buộc',
          timeEvent: 'Ngày diễn ra sự kiện bắt buộc',
          timeEnd: 'Ngày kết thúc sự kiện bắt buộc',
        }
      },
      CHART: {
        NAME: 'Biểu đồ',
        LIST: 'DANH SÁCH BIỂU ĐỒ',
        NEW: 'Thêm mới',
        SEARCH: {
          TITLE: 'Nhập tên biểu đồ'
        },
        DELETE_SIMPLE: {
          TITLE: 'Xóa biểu đồ',
          DESCRIPTION: 'Bạn có thực sự muốn xóa?',
          WAIT_DESCRIPTION: 'Biểu đồ đang xóa...',
          MESSAGE: 'Biểu đồ đã được xóa'
        },
        DELETE_MULTY: {
          TITLE: 'Xóa biểu đồ',
          DESCRIPTION: 'Bạn có thực sự muốn xóa?',
          WAIT_DESCRIPTION: 'Biểu đồ đang xóa...',
          MESSAGE: 'Biểu đồ đã được xóa'
        },
        FILTER_STATUS: {
          ACTIVE: 'Hiển thị',
          INACTIVE: 'Không hiển thị',
          USE: 'Sử dụng',
          UNUSE: 'Không sử dụng',
        },
        MODEL: {
          code: 'Code',
          name: 'Tên biểu đồ',
          description: 'Mô tả',
          status: 'Trạng thái',
          iframe: 'Iframe',
          endpointApi: 'Enpoint',
          menuName: 'Menu',
          useIframe: 'Trạng thái Iframe',
        },
        PLACEHOLDER: {
          CODE: 'Nhập code',
          NAME: 'Nhập tên biểu đồ',
          DESCRIPTION: 'Nhập mô tả',
          STATUS: 'Chọn trạng thái',
          IFRAME: 'Nhập iframe',
          ENDPOINT_API: 'Nhập endpoint',
          MENU_NAME: 'Chọn menu',
          USE_IFRAME: 'Chọn trạng thái',
          EDIT_CHART: 'Sửa biểu đồ',
          DELETE_CHART: 'Xóa biểu đồ',
        },
        VALIDATION: {
          code: 'Code bắt buộc ',
          name: 'Tên biểu đồ bắt buộc ',
          description: 'Mô tả bắt buộc ',
          status: 'Trạng thái bắt buộc ',
          iframe: 'Iframe bắt buộc ',
          endpointApi: 'Enpoint bắt buộc ',
          menuName: 'Menu bắt buộc ',
          useIframe: 'Trạng thái sử dụng bắt buộc ',
        }
      },
      GROUP_CHART: {
        NAME: 'Nhóm biểu đồ',
        LIST: 'DANH SÁCH NHÓM BIỂU ĐỒ',
        NEW: 'Thêm mới',
        SEARCH: {
          TITLE: 'Nhập tên nhóm biểu đồ'
        },
        MODEL: {
          id: 'ID',
          code: 'Code',
          name: 'Tên nhóm biểu đồ',
          description: 'Mô tả',
          status: 'Trạng thái'
        },
        PLACEHOLDER: {
          ID: 'Nhập ID',
          CODE: 'Nhập code',
          NAME: 'Nhập tên nhóm biểu đồ',
          STATUS: 'Chọn trạng thái',
          MENU_NAME: 'Chọn menu',
          EDIT_CHART: 'Sửa nhóm biểu đồ',
          DELETE_CHART: 'Xóa nhóm biểu đồ',
        },
        FILTER_STATUS: {
          ACTIVE: 'Hiển thị',
          INACTIVE: 'Không hiển thị',
          USE: 'Sử dụng',
          UNUSE: 'Không sử dụng',
        },
        VALIDATION: {
          code: 'Code bắt buộc ',
          name: 'Tên nhóm biểu đồ bắt buộc ',
          status: 'Trạng thái bắt buộc ',
        }
      },
      PowerBiUser: {
        NAME: 'Tài khoản PowerBI',
        LIST: 'DANH SÁCH TÀI KHOẢN POWERBI',
        NEW: 'Thêm mới',
        SEARCH: {
          TITLE: 'Nhập tên đăng nhập'
        },
        DELETE_SIMPLE: {
          TITLE: 'Xóa tài khoản powerBI',
          DESCRIPTION: 'Bạn có thực sự muốn xóa?',
          WAIT_DESCRIPTION: 'Tài khoản powerBI đang xóa...',
          MESSAGE: 'Tài khoản powerBI đã được xóa'
        },
        DELETE_MULTY: {
          TITLE: 'Xóa tài khoản powerBI',
          DESCRIPTION: 'Bạn có thực sự muốn xóa?',
          WAIT_DESCRIPTION: 'Tài khoản powerBI đang xóa...',
          MESSAGE: 'Tài khoản powerBI đã được xóa'
        },
        FILTER_STATUS: {
          ACTIVE: 'Hiển thị',
          INACTIVE: 'Không hiển thị',
          USE: 'Sử dụng',
          UNUSE: 'Không sử dụng',
        },
        MODEL: {
          clientId: 'ClientId',
          clientSecret: 'ClientSecret',
          grantType: 'GrantType',
          resource: 'Resource',
          userName: 'UserName',
          password: 'Password',
          status: 'Trạng thái',
          isDefault: 'Tài khoản mặc định',
        },
        PLACEHOLDER: {
          clientId: 'Nhập clientId',
          clientSecret: 'Nhập clientSecret',
          grantType: 'Nhập grantType',
          resource: 'Nhập resource',
          userName: 'Nhập userName',
          password: 'Nhập password',
          status: 'Chọn trạng thái',
          isDefault: 'Chọn tài khoản mặc định',
          EDIT_PowerBiUser: 'Sửa tài khoản powerBI',
          DELETE_PowerBiUser: 'Xóa tài khoản powerBI',
        },
        VALIDATION: {
          clientId: 'ClientId bắt buộc',
          clientSecret: 'ClientSecret bắt buộc',
          grantType: 'GrantType bắt buộc',
          resource: 'Resource bắt buộc',
          userName: 'UserName bắt buộc',
          password: 'Password bắt buộc',
          status: 'Trạng thái bắt buộc',
          isDefault: 'Tài khoản mặc định bắt buộc',
        }
      },
      GUIDELINE: {
        NAME: 'Hướng dẫn sử dụng',
        LIST: 'DANH SÁCH HƯỚNG DẪN SỬ DỤNG',
        NEW: 'Thêm mới',
        SEARCH: {
          TITLE: 'Nhập tên HDSD'
        },
        DELETE_SIMPLE: {
          TITLE: 'Xóa hướng dẫn sử dụng',
          DESCRIPTION: 'Bạn có thực sự muốn xóa?',
          WAIT_DESCRIPTION: 'Hướng dẫn sử dụng đang xóa...',
          MESSAGE: 'Hướng dẫn sử dụng đã được xóa'
        },
        DELETE_MULTY: {
          TITLE: 'Xóa hướng dẫn sử dụng',
          DESCRIPTION: 'Bạn có thực sự muốn xóa?',
          WAIT_DESCRIPTION: 'Hướng dẫn sử dụng đang xóa...',
          MESSAGE: 'Hướng dẫn sử dụng đã được xóa'
        },
        MODEL: {
          name: 'Hướng dẫn sử dụng',
          description: 'Mô tả',
          shortDescription: 'Mô tả ngắn',
          status: 'Trạng thái',
          files: 'File'
        },
        VALIDATION: {
          name: 'Tên hướng dẫn sử dụng bắt buộc',
          description: 'Mô tả bắt buộc',
          shortDescription: 'Mô tả ngắn bắt buộc',
          status: 'Trạng thái bắt buộc',
          files: 'File bắt buộc'
        }
      },
      ROLE: {
        NAME: 'Quyền',
        LIST: 'Danh sách quyền',
        DETAIL: 'Chi tiết quyền',
        NEW: 'Thêm mới',
        DELETE_SIMPLE: {
          TITLE: 'Xóa quyền',
          DESCRIPTION: 'Bạn có thực sự muốn xóa?',
          WAIT_DESCRIPTION: 'Quyền đang xóa...',
          MESSAGE: 'Quyền đã được xóa'
        },
        DELETE_MULTY: {
          TITLE: 'Xóa quyền',
          DESCRIPTION: 'Bạn có thực sự muốn xóa?',
          WAIT_DESCRIPTION: 'Quyền đang xóa...',
          MESSAGE: 'Quyền đã được xóa'
        },
        MODEL: {
          name: 'Tên Quyền',
          description: 'Mô tả quyền',
          status: 'Kích hoạt',
        },
        VALIDATION: {
        }
      },
      WIDGET: {
        WIDGET: 'Khối thông tin',
        WIDGET_LIST: 'DANH SÁCH KHỐI THÔNG TIN',
        NEW_WIDGET: 'Thêm mới',
        SEARCH: {
          TITLE: 'Nhập tên khối thông tin',
          NAME: 'Nhập tên khối thông tin',
          CODE: 'Nhập mã khối thông tin',
          DESCRIPTION: 'Nhập mô tả',
          STATUS: 'Chọn trạng thái'
        },
        DELETE_WIDGET_SIMPLE: {
          TITLE: 'Xóa khối thông tin',
          DESCRIPTION: 'Bạn có thực sự muốn xóa?',
          WAIT_DESCRIPTION: 'Khối thông tin đang xóa...',
          MESSAGE: 'Khối thông tin đã được xóa'
        },
        DELETE_WIDGET_MULTY: {
          TITLE: 'Xóa khối thông tin',
          DESCRIPTION: 'Bạn có thực sự muốn xóa?',
          WAIT_DESCRIPTION: 'Khối thông tin đang xóa...',
          MESSAGE: 'Khối thông tin đã được xóa'
        },
        UPDATE_STATUS: {
          TITLE: 'Trạng thái đã được cập nhật',
          MESSAGE: 'Trạng thái đã được cập nhật thành công'
        },
        EDIT: {
          UPDATE_MESSAGE: 'Khối thông tin đã được cập nhật',
          ADD_MESSAGE: 'Khối thông tin đã được tạo'
        },
        GRANT_PERMISSION: {
          ASSIGN_ROLE: 'Gán nhóm người dùng',
          REMOVE_ROLE: 'Bỏ gán nhóm người dùng'
        },
        FILTER_STATUS: {
          TITLE: 'Lọc theo trạng thái',
          ACTIVE: 'Hiển thị',
          INACTIVE: 'Không hiển thị'
        },
        MODEL: {
          ID: 'Id',
          CODE: 'Mã khối thông tin',
          NAME: 'Tên khối thông tin',
          DESCRIPTION: 'Mô tả',
          STATUS: 'Trạng thái',
          ACTION: 'Thao tác'
        },
        PLACE_HOLDER: {
          NAME: 'Nhập tên khối thông tin',
          CODE: 'Nhập mã khối thông tin',
          DESCRIPTION: 'Nhập mô tả',
          EDIT_WIDGET: 'Sửa khối thông tin'
        },
        VALIDATION: {
          NAME_REQUIRED: 'Tên khối thông tin bắt buộc',
          NAME_ALLOW: 'hợp lệ',
          NAME_MINLENGTH: 'Tên khối thông tin tối thiểu ',
          NAME_MAXLENGTH: 'Tên khối thông tin giới hạn ',
          CODE_REQUIRED: 'Mã khối thông tin bắt buộc',
          CODE_ALLOW: 'Hợp lệ'
        }
      },
      WIDGET_PERMISSION: {
        WIDGET_PERMISSION: 'DANH SÁCH PHÂN QUYỀN KHỐI THÔNG TIN',
        SEARCH: {
          TITLE: 'Tìm kiếm tên vai trò'
        },
        MODAL: {
          ADD_USER_TITLE: 'Danh sách người dùng được phân quyền vào khối thông tin',
          ADD_ROLE_TITLE: 'Danh sách nhóm người dùng được phân quyền vào khối thông tin'
        },
        MODEL: {
          STT: 'STT',
          ROLE: 'Vai trò',
          GROUP: 'Nhóm người dùng'
        },
        PLACEHOLDER: {
          DELETE_PERMISSION: 'Xóa phân quyền',
        }
      },
      NOTIFICATIONS: {
        NAME: 'DANH SÁCH LOẠI THÔNG BÁO',
        NAME_EDIT: 'loại thông báo',
        MODEL: {
          NAME: 'Tiêu đề',
          DESCRIPTION: 'Mô tả',
          TIME: 'Thời gian gửi',
          STATUS: 'Trạng thái',
          MAIL: 'Gửi mail',
          TIMER: 'Hẹn thời gian gửi',
          IMPORTANCE: 'Độ khẩn',
          CONTENT: 'Nội dung'
        },
        PLACEHOLDER: {
          NAME_INPUT: 'Nhập tiêu đề',
          INPUT_SEARCH: 'Nhập tiêu đề',
          TIME_INPUT: 'Nhập thời gian',
          TIMER_INPUT: 'Hẹn thời gian gửi',
          CONTENT_INPUT: 'Nhập nội dung',
          IMPORTANCE_SELECT: 'Chọn độ khẩn',
          DESCRIPTION_INPUT: 'Nhập mô tả',
          STATUS_INPUT: 'Chọn trạng thái'
        },
        VALIDATION: {
          REQUIRE_VALID: 'bắt buộc',
          MAX_LENGTH_FIELD: 'Độ dài giới hạn'
        }
      }
    },
    SSO: {
      COMMON: {
        NAME: 'SSO',
        SELECTED_RECORDS_COUNT: 'Số dòng đã chọn: ',
        ALL: 'Tất cả',
        ACTIVE: 'Hiển thị',
        INACTIVE: 'Ngừng Hiển thị',
        FILTER: 'Lọc',
        BY_STATUS: 'Theo trạng thái',
        SEARCH: 'Tìm kiếm',
        IN_ALL_FIELDS: 'Tất cả các trường',
        CANCEL: 'Hủy bỏ',
        CREATE: 'Thêm mới',
        EDIT: 'Chỉnh sửa',
        DELETE: 'Xóa',
        SAVE: 'Lưu',
        VALIDATION_CHARACTER: ' ký tự'
      },
      CONFIG: {
        NAME: 'DANH SÁCH CẤU HÌNH SSO',
        LIST: 'Danh sách cấu hình',
        NEW: 'Thêm mới',
        DELETE_SIMPLE: {
          TITLE: 'Xóa cấu hình',
          DESCRIPTION: 'Bạn có thực sự muốn xóa?',
          WAIT_DESCRIPTION: 'Cấu hình đang xóa...',
          MESSAGE: 'Cấu hình đã được xóa'
        },
        DELETE_MULTY: {
          TITLE: 'Xóa cấu hình',
          DESCRIPTION: 'Bạn có thực sự muốn xóa?',
          WAIT_DESCRIPTION: 'Cấu hình đang xóa...',
          MESSAGE: 'Cấu hình đã được xóa'
        },
        FILTER_STATUS: {
          TITLE: 'Lọc theo trạng thái',
          ACTIVE: 'Sử dụng',
          INACTIVE: 'Không sử dụng'
        },
        MODEL: {
          URL: 'Đường dẫn',
          CLIENT_ID: 'Client ID',
          CLIENT_SECRET: 'Client secret',
          RESPONSE_TYPE: 'Response type',
          SCOPE: 'Scope',
          STATUS: 'Trạng thái',
          REDIRECT_URI: 'Redirect uri',
          APP: 'Ứng dụng'
        },
        PLACE_HOLDER: {
          URL: 'Nhập đường dẫn',
          CLIENT_ID: 'Nhập client id',
          CLIENT_SECRET: 'Nhập client secret',
          RESPONSE_TYPE: 'Nhập response type',
          REDIRECT_URI: 'Nhập redirect uri',
          SCOPE: 'Chọn scope',
          APP: 'Chọn ứng dụng'
        },
        VALIDATION: {
          ALLOW: 'Hợp lệ',
          REQUIRED: 'Bắt buộc'
        }
      },
    },
    FORM: {
      VALIDATION: {
        INVALIDNoName: 'hợp lệ',
        REQUIREDNoName: 'Bắt buộc',
        CREATESUCCESS: 'Thêm mới thành công',
        UPDATESUCCESS: 'Chỉnh sửa thành công',
        DELETESUCCESS: 'Xóa thành công',
        FORMATDATE: 'Định dạng của ngày: dd/MM/yyyy',
        PHONE_NUMBER_ERROR: ' Số điện thoại không hợp lệ',
        INVALID: 'sai định dạng',
      }
    },
    QRCODE: {
      QRCODE: {
        NAME: 'QR Code',
        NAME_LIST: 'DANH SÁCH QR CODE',
        NEW_NAME: 'Thêm mới',
        DELETE_QRCODE_SIMPLE: {
          TITLE: 'Xóa QR Code',
          DESCRIPTION: 'Bạn có thực sự muốn xóa?',
          WAIT_DESCRIPTION: 'QR Code đang xóa...',
          MESSAGE: 'QR Code đã được xóa'
        },
        DELETE_QRCODE_MULTY: {
          TITLE: 'Xóa QRCode',
          DESCRIPTION: 'Bạn có thực sự muốn xóa?',
          WAIT_DESCRIPTION: 'QR Code đang xóa...',
          MESSAGE: 'QR Code đã được xóa'
        },
        UPDATE_STATUS: {
          TITLE: 'Trạng thái đã được cập nhật',
          MESSAGE: 'Trạng thái đã được cập nhật thành công'
        },
        EDIT: {
          UPDATE_MESSAGE: 'QR Code đã được cập nhật',
          ADD_MESSAGE: 'QR Code đã được tạo'
        },
        FILTER_STATUS: {
          TITLE: 'Lọc theo trạng thái',
          ACTIVE: 'Hiển thị',
          INACTIVE: 'Không hiển thị'
        },
        MODEL: {
          typeDevice: 'Loại máy',
          imagePath: 'Ảnh QR Code',
          status: 'Trạng thái',
        },
        VALIDATION: {
          typeDevice: 'Loại máy bắt buộc',
        }
      },
    },
    SYSTEM_MANAGEMENT: {
      COMMON: {
        SELECTED_RECORDS_COUNT: 'Số dòng đã chọn: ',
        ALL: 'Tất cả',
        ACTIVE: 'Hiển thị',
        INACTIVE: 'Ngừng Hiển thị',
        FILTER: 'Lọc',
        BY_STATUS: 'Theo trạng thái',
        SEARCH: 'Tìm kiếm',
        IN_ALL_FIELDS: 'Tất cả các trường',
        CANCEL: 'Hủy bỏ',
        CREATE: 'Thêm mới',
        EDIT: 'Chỉnh sửa',
        DELETE: 'Xóa',
        SAVE: 'Lưu',
        VALIDATION_CHARACTER: ' ký tự',
        GENERAL_INFORMATION: 'Thông tin chung',
        ORGANIZATION_STRUCTURE: 'Cơ cấu tổ chức',
        CHOOSE_IMAGE: 'Chọn ảnh'
      },
      GROUP: {
        GROUP: 'Nhóm người dùng',
        GROUP_ICON: 'nhóm người dùng',
        USER_ICON: 'người dùng',
        GROUP_LIST: 'DANH SÁCH NHÓM NGƯỜI DÙNG',
        NEW_GROUP: 'Thêm mới',
        DELETE_GROUP_SIMPLE: {
          TITLE: 'Xóa nhóm người dùng',
          DESCRIPTION: 'Bạn có thực sự muốn xóa?',
          WAIT_DESCRIPTION: 'Nhóm người dùng đang xóa...',
          MESSAGE: 'Nhóm người dùng đã được xóa'
        },
        DELETE_GROUP_MULTY: {
          TITLE: 'Xóa nhóm người dùng',
          DESCRIPTION: 'Bạn có thực sự muốn xóa?',
          WAIT_DESCRIPTION: 'Nhóm người dùng đang xóa...',
          MESSAGE: 'Nhóm người dùng đã được xóa'
        },
        UPDATE_STATUS: {
          TITLE: 'Trạng thái đã được cập nhật',
          MESSAGE: 'Trạng thái đã được cập nhật thành công'
        },
        EDIT: {
          UPDATE_MESSAGE: 'Nhóm người dùng đã được cập nhật',
          ADD_MESSAGE: 'Nhóm người dùng đã được tạo'
        },
        FILTER_STATUS: {
          TITLE: 'Lọc theo trạng thái',
          ACTIVE: 'Hiển thị',
          INACTIVE: 'Không hiển thị',
          USE: 'Sử dụng',
          UNUSE: 'Không sử dụng'
        },
        MODEL: {
          ID: 'Id',
          GROUP_NAME: 'Tên nhóm',
          DESCRIPTION: 'Mô tả',
          STATUS: 'Trạng thái',
          USERS: 'Người dùng',
          ACTION: 'Thao tác'
        },
        VALIDATION: {
          GROUP_NAME_REQUIRED: 'Tên nhóm bắt buộc',
          GROUP_NAME_ALLOW: 'Tên nhóm hợp lệ',
          ROLE_REQUIRED: 'Vai trò bắt buộc',
          ROLE_ALLOW: 'Vai trò hợp lệ',
          GROUP_NAME_MINLENGTH: 'Tên nhóm tối thiểu ',
          GROUP_NAME_MAXLENGTH: 'Tên nhóm giới hạn ',
          GROUP_MAXLENGTH: 'Nhóm người dùng giới hạn ',
          DESCRIPTION_MINLENGTH: 'Mô tả tối thiểu ',
          DESCRIPTION_MAXLENGTH: 'Mô tả giới hạn '
        }
      },
      ORGANIZATION: {
        NAME: 'Cấp đơn vị',
        NAME_ICON: 'cấp đơn vị',
        ORGANIZATION: 'Quản lý cấp đơn vị',
        ORGANIZATION_LIST: 'DANH SÁCH CẤP ĐƠN VỊ',
        NEW_ORGANIZATION: 'Thêm mới',
        DELETE_ORGANIZATION_SIMPLE: {
          TITLE: 'Xóa cấp đơn vị',
          DESCRIPTION: 'Bạn có thực sự muốn xóa?',
          WAIT_DESCRIPTION: 'Cấp đơn vị đang xóa...',
          MESSAGE: 'Cấp đơn vị đã được xóa'
        },
        DELETE_ORGANIZATION_MULTY: {
          TITLE: 'Xóa cấp đơn vị',
          DESCRIPTION: 'Bạn có thực sự muốn xóa?',
          WAIT_DESCRIPTION: 'Cấp đơn vị đang xóa...',
          MESSAGE: 'Cấp đơn vị đã được xóa'
        },
        UPDATE_STATUS: {
          TITLE: 'Trạng thái đã được cập nhật',
          MESSAGE: 'Trạng thái đã được cập nhật thành công'
        },
        EDIT: {
          UPDATE_MESSAGE: 'Cấp đơn vị đã được cập nhật',
          ADD_MESSAGE: 'Cấp đơn vị đã được tạo'
        },
        FILTER_STATUS: {
          TITLE: 'Lọc theo trạng thái',
          ACTIVE: 'Hiển thị',
          INACTIVE: 'Ngừng Hiển thị'
        },
        MODEL: {
          ID: 'Id',
          CODE: 'Mã cấp đơn vị',
          NAME: 'Tên cấp đơn vị',
          DESCRIPTION: 'Mô tả',
          STATUS: 'Trạng thái',
          ADDRESS: 'Địa chỉ',
          CREATED_DATE: 'Ngày tạo',
          ACTION: 'Thao tác',
          fileUpload: 'Tải file',
          parentOrganizationId: 'Cấp đơn vị cha',
          POSITION: 'Vị trí',
          CADRES: 'Cán bộ'
        },
        PLACE_HOLDER: {
          NAME: 'Nhập tên cấp đơn vị',
          CODE: 'Mã cấp đơn vị',
          CODE_INPUT: 'Nhập mã cấp đơn vị',
          DESCRIPTION: 'Nhập mô tả',
          STATUS: 'Chọn trạng thái',
          ADDRESS: 'Nhập địa chỉ',
          POSITION: 'Chọn vị trí',
          CADRES: 'Chọn cán bộ'
        },
        VALIDATION: {
          NAME_REQUIRED: 'Tên đơn vị bắt buộc',
          NAME_ALLOW: 'Tên đơn vị hợp lệ',
          CODE_REQUIRED: 'Mã cấp đơn vị bắt buộc',
          CODE_ALLOW: 'Mã cấp đơn vị hợp lệ',
          POSITION_REQUIRED: 'Vị trí bắt buộc',
          POSITION_ALLOW: 'Vị trí hợp lệ',
          CADRES_REQUIRED: 'Cán bộ bắt buộc',
          CADRES_ALLOW: 'Cán bộ hợp lệ',
          NAME_MINLENGTH: 'Tên đơn vị tối thiểu ',
          NAME_MAXLENGTH: 'Tên đơn vị giới hạn ',
          CODE_MINLENGTH: 'Mã đơn vị tối thiểu ',
          CODE_MAXLENGTH: 'Mã đơn vị giới hạn ',
          DESCRIPTION_MINLENGTH: 'Mô tả tối thiểu ',
          DESCRIPTION_MAXLENGTH: 'Mô tả giới hạn ',
          ADDRESS_MINLENGTH: 'Địa chỉ tối thiểu ',
          ADDRESS_MAXLENGTH: 'Địa chỉ giới hạn ',
          ID: 'Id bắt buộc',
          NAME: 'Tên cấp đơn vị bắt buộc',
          CODE: 'Mã cấp đơn vị bắt buộc',
          DESCRIPTION: 'Mô tả bắt buộc',
          STATUS: 'Trạng thái bắt buộc',
          ADDRESS: 'Địa chỉ bắt buộc',
          ACTION: 'Thao tác bắt buộc',
          fileUpload: 'Tải file bắt buộc',
          parentOrganizationId: 'Cấp đơn vị cha bắt buộc',
        }
      },
      ROLE: {
        ROLE: 'Vai trò',
        ROLE_LIST: 'DANH SÁCH NHÓM NGƯỜI DÙNG',
        NEW_ROLE: 'Thêm mới',
        SEARCH: {
          TITLE: 'Nhập tên nhóm người dùng'
        },
        DELETE_ROLE_SIMPLE: {
          TITLE: 'Xóa vai trò',
          DESCRIPTION: 'Bạn có thực sự muốn xóa?',
          WAIT_DESCRIPTION: 'Vai trò đang xóa...',
          MESSAGE: 'Vai trò đã được xóa'
        },
        DELETE_ROLE_MULTY: {
          TITLE: 'Xóa vai trò',
          DESCRIPTION: 'Bạn có thực sự muốn xóa?',
          WAIT_DESCRIPTION: 'Vai trò đang xóa...',
          MESSAGE: 'Vai trò đã được xóa'
        },
        ASSIGN_USER: {
          TITLE: 'Gán người dùng'
        },
        REMOVE_USER: {
          TITLE: 'Bỏ gán người dùng'
        },
        ASSIGN_PERMISSION: {
          TITLE: 'Gán quyền'
        },
        REMOVE_PERMISSION: {
          TITLE: 'Bỏ gán quyền'
        },
        UPDATE_STATUS: {
          TITLE: 'Trạng thái đã được cập nhật',
          MESSAGE: 'Trạng thái đã được cập nhật thành công'
        },
        EDIT: {
          UPDATE_MESSAGE: 'Nhóm người dùng đã được cập nhật',
          ADD_MESSAGE: 'Nhóm người dùng đã được tạo'
        },
        FILTER_STATUS: {
          TITLE: 'Lọc theo trạng thái',
          ACTIVE: 'Hiển thị',
          INACTIVE: 'Không hiển thị'
        },
        MODEL: {
          ID: 'Id',
          NAME: 'Nhóm người dùng',
          DESCRIPTION: 'Mô tả',
          STATUS: 'Trạng thái',
          ACTION: 'Thao tác',
          CREATEDATE: 'Ngày tạo'
        },
        PLACE_HOLDER: {
          NAME: 'Nhập tên nhóm người dùng',
          DESCRIPTION: 'Nhập mô tả',
          STATUS: 'Chọn trạng thái'
        },
        VALIDATION: {
          NAME_REQUIRED: 'Nhóm người dùng bắt buộc',
          NAME_ALLOW: 'Nhóm người dùng hợp lệ',
          NAME_MINLENGTH: 'Nhóm người dùng tối thiểu ',
          NAME_MAXLENGTH: 'Nhóm người dùng giới hạn ',
          DESCRIPTION_MINLENGTH: 'Mô tả tối thiểu ',
          DESCRIPTION_MAXLENGTH: 'Mô tả giới hạn '
        }
      },
      USER: {
        USER: 'Người dùng',
        USER_ICON: 'người dùng',
        USER_LIST: 'DANH SÁCH NGƯỜI DÙNG',
        SEARCH: {
          TITLE: 'Nhập tên đăng nhập, họ và tên'
        },
        DELETE_USER_SIMPLE: {
          TITLE: 'Xóa người dùng',
          DESCRIPTION: 'Bạn có thực sự muốn xóa?',
          WAIT_DESCRIPTION: 'Người dùng đang xóa...',
          MESSAGE: 'Người dùng đã được xóa'
        },
        DELETE_USER_MULTY: {
          TITLE: 'Xóa người dùng',
          DESCRIPTION: 'Bạn có thực sự muốn xóa?',
          WAIT_DESCRIPTION: 'Người dùng đang xóa...',
          MESSAGE: 'Người dùng đã được xóa'
        },
        UPDATE_STATUS: {
          TITLE: 'Trạng thái đã được cập nhật',
          MESSAGE: 'Trạng thái đã được cập nhật thành công'
        },
        EDIT: {
          UPDATE_MESSAGE: 'Người dùng đã được cập nhật',
          ADD_MESSAGE: 'Người dùng đã được tạo'
        },
        FILTER_STATUS: {
          TITLE: 'Lọc theo trạng thái',
          ACTIVE: 'Mở khóa',
          INACTIVE: 'Khóa'
        },
        MODEL: {
          ID: 'Id',
          USER_NAME: 'Tên đăng nhập',
          FULLNAME: 'Họ và tên',
          PHONE: 'Số điện thoại',
          EMAIL: 'Email',
          ROLENAME: 'Vai trò',
          ORGANIZATION: 'Đơn vị',
          STATUS: 'Trạng thái',
          ACTION: 'Thao tác',
          POSITION: 'Chức danh',
          SEX: 'Giới tính'
        },
        PLACE_HOLDER: {
          USER_NAME: 'Nhập tên đăng nhập',
          PHONE: 'Nhập SĐT',
          EMAIL: 'Nhập email',
          ROLENAME: 'Chọn vai trò',
          FULLNAME: 'Nhập họ và tên',
          POSITION: 'Chọn chức danh'
        },
        VALIDATION: {
          USER_NAME_REQUIRED: 'Người dùng bắt buộc',
          USER_NAME_ALLOW: 'Người dùng hợp lệ',
          EMAIL_REQUIRED: 'Email bắt buộc',
          EMAIL_ALLOW: 'Địa chỉ email hợp lệ',
          EMAIL_NOTALLOW: 'Địa chỉ email không hợp lệ',
          USER_NAME_MINLENGTH: 'Người dùng tối thiểu ',
          USER_NAME_MAXLENGTH: 'Người dùng giới hạn ',
          ROLE_NAME_REQUIRED: 'Vai trò bắt buộc',
          ROLE_NAME_ALLOW: 'Vai trò hợp lệ',
          GROUP_NAME_REQUIRED: 'Nhóm người dùng bắt buộc',
          GROUP_NAME_ALLOW: 'Nhóm người dùng hợp lệ',
          FULL_NAME_MAXLENGTH: 'Họ và tên giới hạn ',
          FULL_NAME_REQUIRED: 'Họ và tên bắt buộc ',
          PHONE_REQUIRED: 'Số điện thoại bắt buộc ',
          SEX_REQUIRED: 'Giới tính bắt buộc ',
          POSITION_REQUIRED: 'Chức danh bắt buộc ',
          DEPARTMENT_REQUIRED: 'Đơn vị bắt buộc ',
        }
      },
      PERMISSION: {
        PERMISSION: 'Quyền',
        PERMISSION_LIST: 'DANH SÁCH THÔNG TIN QUẢN LÝ QUYỀN',
        PERMISSION_LISTS: 'Danh sách chức năng',
        SEARCH: {
          TITLE: 'Nhập tên chức năng'
        },
        ASSIGN: {
          UPDATE_MESSAGE: 'Quyền đã được cập nhật',
          ADD_MESSAGE: 'Quyền đã được tạo'
        },
        FILTER_STATUS: {
          TITLE: 'Lọc theo trạng thái',
          ACTIVE: 'Hiển thị',
          INACTIVE: 'Ngừng Hiển thị'
        },
        MODEL: {
          ID: 'Id',
          NAME: 'Tên quyền',
          DESCRIPTION: 'Mô tả',
          STATUS: 'Trạng thái',
          ROLES: 'Nhóm người dùng',
          ORGANIZATION: 'Đơn vị',
          DEPARTMENT: 'Cơ cấu tổ chức',
          ACTION: 'Thao tác'
        },
        PLACE_HOLDER: {
          NAME: 'Nhập tên quyền',
          DESCRIPTION: 'Nhập mô tả'
        },
        VALIDATION: {
          NAME_REQUIRED: 'Chọn quyền bắt buộc',
          NAME_ALLOW: 'Quyền chọn hợp lệ',
        }
      },


      ROLE_MANAGE: {
        ROLE_MANAGE: 'Vai trò',
        ROLE_ICON: 'vai trò',
        ROLE_MANAGE_LIST: 'DANH SÁCH VAI TRÒ',
        SEARCH: {
          TITLE: 'Nhập tên vai trò'
        },
        ASSIGN: {
          UPDATE_MESSAGE: 'Vai trò đã được cập nhật',
          ADD_MESSAGE: 'Vai trò đã được tạo'
        },
        FILTER_STATUS: {
          TITLE: 'Lọc theo trạng thái',
          ACTIVE: 'Hiển thị',
          INACTIVE: 'Ngừng Hiển thị'
        },
        MODEL: {
          ID: 'Id',
          NAME: 'Tên vai trò',
          DESCRIPTION: 'Mô tả',
          STATUS: 'Trạng thái',
          ACTION: 'Thao tác',
          CREATEDATE: 'Ngày tạo',
          CODE: 'Mã vai trò'
        },
        PLACE_HOLDER: {
          NAME: 'Nhập tên vai trò',
          DESCRIPTION: 'Nhập mô tả',
          CODE: 'Mã vai trò'
        },
        VALIDATION: {
          NAME_REQUIRED: 'Tên vai trò bắt buộc',
          NAME_ALLOW: 'Tên vai trò chọn hợp lệ',
          DESCRIPTION_REQUIRED: 'Mô tả bắt buộc',
          DESCRIPTION_ALLOW: 'Mô tả trò chọn hợp lệ',
        }
      },

      EMPLOYEEMANAGEMENT: {
        MENU: 'Quản lý hồ sơ cán bộ',
        NAME: 'Hồ sơ cán bộ',
        NAME_ICON: 'hồ sơ cán bộ',
        LIST: 'DANH SÁCH HỒ SƠ CÁN BỘ',
        NEW: 'Thêm mới',
        LOCK_UNLOCK: 'Khóa/Mở khóa',
        DELETE_SIMPLE: {
          TITLE: 'Xóa hồ sơ cán bộ',
          DESCRIPTION: 'Bạn có thực sự muốn xóa?',
          WAIT_DESCRIPTION: 'Hồ sơ cán bộ đang xóa...',
          MESSAGE: 'Hồ sơ cán bộ đã được xóa',
        },
        DELETE_MULTY: {
          TITLE: 'Xóa hồ sơ cán bộ',
          DESCRIPTION: 'Bạn có thực sự muốn xóa?',
          WAIT_DESCRIPTION: 'Hồ sơ cán bộ đang xóa...',
          MESSAGE: 'Hồ sơ cán bộ đã được xóa'
        },
        MODEL: {
          fullName: 'Họ và tên',
          sex: 'Giới tính',
          dateOfBirth: 'Ngày sinh',
          address: 'Địa chỉ',
          phoneNumber: 'SĐT',
          status: 'Trạng thái',
          departmantId: 'Đơn vị',
          dateCreate: 'Ngày tạo',
          position: 'Chức vụ',
          industryCode: 'Mã cán bộ',
          cccd: 'CMND/CCCD',
          email: 'Email',
          roleName: 'Vai trò',
          departmantName: 'Đơn vị công tác'
        },
        PLACE_HOLDER: {
          CODE: 'Nhập mã cán bộ',
          FULLNAME: 'Nhập họ và tên',
          SEX: 'Chọn giới tính',
          DATE_OF_BIRTH: 'Nhập ngày sinh',
          ADDRESS: 'Nhập quê quán',
          PHONE_NUMBER: 'Nhập SĐT',
          STATUS: 'Chọn trạng thái',
          DEPARTMENT: 'Chọn đơn vị',
          POSITION: 'Nhập chức vụ',
          INDUSTRYCODE: 'Nhập mã ngành',
          CCCD: 'Nhập số CMND/CCCD',
          EMAIL: 'Nhập email',
          ORGANIZATION: 'Chọn đơn vị',
          ROLE: 'Chọn vai trò',
          CREATEDATE: 'Chọn ngày tạo'
        },
        VALIDATION: {
          fullName: 'Họ và tên bắt buộc',
          sex: 'Giới tính bắt buộc',
          dateOfBirth: 'Ngày sinh bắt buộc',
          address: 'Quê quán bắt buộc',
          phoneNumber: 'SĐT bắt buộc',
          status: 'Trạng thái bắt buộc',
          departmantId: 'Đơn vị bắt buộc',
          position: 'Chức vụ bắt buộc',
          industryCode: 'Mã ngành bắt buộc',
          cccd: 'CMND/CCCD bắt buộc',
          email: 'Email bắt buộc',
          more_than_or_equal_to: 'nhiều hơn hoặc bằng',
          or: 'hoặc',
          contains_only: 'chỉ chứa',
          limit: 'giới hạn'
        }
      },
      DEPARTMENT: {
        MENU: 'Quản lý thông tin đơn vị',
        NAME: 'Thông tin đơn vị',
        NAME_ICON: 'thông tin đơn vị',
        LIST: 'DANH SÁCH THÔNG TIN ĐƠN VỊ',
        NEW: 'Thêm mới',
        DELETE_SIMPLE: {
          TITLE: 'Xóa thông tin đơn vị',
          DESCRIPTION: 'Bạn có thực sự muốn xóa?',
          WAIT_DESCRIPTION: 'Thông tin đơn vị đang xóa...',
          MESSAGE: 'Thông tin đơn vị đã được xóa'
        },
        DELETE_MULTY: {
          TITLE: 'Xóa thông tin đơn vị',
          DESCRIPTION: 'Bạn có thực sự muốn xóa?',
          WAIT_DESCRIPTION: 'Thông tin đơn vị đang xóa...',
          MESSAGE: 'Thông tin đơn vị đã được xóa'
        },
        MODEL: {
          name: 'Tên đơn vị',
          description: 'Mô tả',
          status: 'Trạng thái',
          code: 'Mã đơn vị',
          organizationId: 'Cấp đơn vị',
          createdDate: 'Ngày tạo',
          parentDepartmantId: 'Cấp thông tin đơn vị cha',
          phoneNumber: 'Số điện thoại',
          address: 'Địa chỉ',
          HTBC: 'Mã hệ thống báo cáo',
          EOffice: 'Mã hệ thống E-Office',
          PMIS: 'Mã hệ thống PMIS',
          CSDL: 'Mã hệ thống CSDL ngành'
        },
        PLACE_HOLDER: {
          NAME: 'Nhập tên đơn vị',
          DESCRIPTION: 'Nhập mô tả',
          STATUS: 'Chọn trạng thái',
          CODE: 'Nhập mã đơn vị',
          ORGANIZATION: 'Chọn cấp đơn vị',
          ORGANIZATION_NAME: 'Nhập tên cấp đơn vị',
          PROVINCE: 'Tỉnh',
          DISTRICT: 'Huyện',
          WARD: 'Xã',
          MDV: 'IOCXXXX',
          PHONE: 'Nhập số điện thoại',
          ADDRESS: 'Nhập số nhà, số đường',
          HTBC: ' Nhập mã báo cáo',
          EOffice: 'Nhập mã E-Office',
          PMIS: 'Nhập mã PMIS',
          CSDL: 'Nhập mã CSDL ngành'
        },
        VALIDATION: {
          name: 'Tên đơn vị bắt buộc',
          description: 'Mô tả bắt buộc',
          status: 'Trạng thái bắt buộc',
          code: 'Mã đơn vị bắt buộc',
          organizationId: 'Cấp đơn vị bắt buộc',
          parentDepartmantId: 'Cấp thông tin đơn vị cha bắt buộc'
        }
      },
      LOG: {
        NAME: 'DANH SÁCH NHẬT KÝ HỆ THỐNG',
        LIST: 'Nhật ký hệ thống',
        NEW: 'Thêm mới',
        DELETE_SIMPLE: {
          TITLE: 'Xóa nhật ký hệ thống',
          DESCRIPTION: 'Bạn có thực sự muốn xóa?',
          WAIT_DESCRIPTION: 'nhật ký hệ thống đang xóa...',
          MESSAGE: 'Nhật ký hệ thống đã được xóa'
        },
        DELETE_MULTY: {
          TITLE: 'Xóa nhật ký hệ thống',
          DESCRIPTION: 'Bạn có thực sự muốn xóa?',
          WAIT_DESCRIPTION: 'nhật ký hệ thống đang xóa...',
          MESSAGE: 'Nhật ký hệ thống đã được xóa'
        },
        MODEL: {
          message: 'Thông tin',
          messageTemplate: 'Hành động',
          level: 'Cấp độ',
          timeStamp: 'Thời gian',
          exception: 'Ngoại lệ',
          properties: 'Đặc tính',
          logEvent: 'Sự kiện',
          userName: 'Người thực hiện',
          iP: 'Địa chỉ ip'
        },
        PLACE_HOLDER: {
          MESSAGE: 'Nhập thông tin',
          TIME_STAMP: 'Nhập thời gian',
          EXCEPTION: 'Nhập ngoại lệ',
          USER_NAME: 'Nhập người thực hiện',
          IP: 'Nhập IP'
        },
        VALIDATION: {
        }
      },
      DECENTRALIZATION: {
        DECENTRALIZATION_TITLE: 'DANH SÁCH PHÂN QUYỀN CHỨC NĂNG',
        CHOOSE_ROLE: 'Chọn vai trò',
        PLACEHOLDER: {

        }
      },
      INTEGRATED_SYSTEM: {
        TITLE: 'DANH SÁCH CÁC HỆ THỐNG TÍCH HỢP',
        MODEL: {
          NAME: 'Tên hệ thống',
          URL: 'Đường dẫn',
          DESCRIPTION: 'Mô tả'
        },
        PLACEHOLDER: {
          SEARCH: 'Nhập tên hệ thống',
          PLACE_Name: 'Nhập tên hệ thống',
          PLACE_Url: 'Nhập đường dẫn',
          PLACE_Des: 'Nhập mô tả',
        }
      },
      INTEGRATED_API: {
        TITLE: 'DANH SÁCH CÁC API TÍCH HỢP',
        MODEL: {
          BASEURL: 'BaseURL',
          ENDPOINT: 'EndPoint',
          CODE: 'Code',
          INTEGRATED_SYSTEM: 'Tên hệ thống tích hợp',
        },
        PLACEHOLDER: {
          SEARCH: 'Nhập tên Api tích hợp',
          PLACE_BASEURL: 'Nhập Base URL',
          PLACE_ENDPOINT: 'Nhập EndPoint',
          PLACE_INTEGRATED_SYSTEM: 'Nhập tên hệ thống tích hợp',
        }
      },
    },
    COMMON: {
      SELECTED_RECORDS_COUNT: 'Số dòng đã chọn: ',
      ALL: 'Tất cả',
      ACTIVE: 'Hiển thị',
      INACTIVE: 'Ngừng Hiển thị',
      FILTER: 'Lọc',
      BY_STATUS: 'theo trạng thái',
      BY_ROLE: 'theo vai trò',
      SEARCH: 'Tìm kiếm',
      IN_ALL_FIELDS: 'Tất cả các trường',
      CANCEL: 'Hủy',
      EXIT: 'Thoát',
      CHOOSE_ROLE: 'Chọn vai trò',
      CHOOSE_LEVEL: 'Chọn cấp độ',
      CHOOSE_USER: 'Chọn người dùng',
      CHOOSE_PERMISSION: 'Chọn quyền',
      CREATE: 'Thêm mới',
      INFO: 'Thông tin',
      EDIT: 'Chỉnh sửa',
      GRANT: 'Phân quyền',
      BACK: 'Trờ lại',
      DELETE: 'Xóa',
      DELETE_SELECTED: 'Xóa đã chọn',
      DETAIL: 'Chi tiết',
      SAVE: 'Lưu',
      VALIDATION_CHARACTER: ' ký tự',
      UPLOAD: 'Đính kèm',
      SAVE_ORDER: 'Lưu thứ tự',
      GRANT_PERMISSION: 'Phân quyền',
      ACCESS_PERMISSION: 'Truy cập',
      IMPORT: 'Nhập excel',
      EXPORT: 'Xuất excel',
      ACTION: 'Thao tác',
      SHARE: 'Chia sẻ',
      SEND: 'Gửi',
      STT: 'STT',
      ALLSELECT: 'Tất cả',
      FILTER_STATUS: {
        TITLE: 'Chọn trạng thái',
        ACTIVE: 'Hiển thị',
        INACTIVE: 'Không hiển thị'
      },
      FILTER_STATUS_USE: {
        TITLE: 'Chọn trạng thái',
        ACTIVE: 'Sử dụng',
        INACTIVE: 'Không sử dụng'
      },
      LESS: 'rút gọn',
      SHOWMORE: 'xem thêm',
      API_ERROR: ' không load được. Vui lòng liện hệ quản trị viên để xử lý.',
      TEMPLATE_EXCEL: 'Tải file mẫu',
      DELETE_POPUP: 'Bạn chắc chắn muốn xóa bản ghi đã chọn?',
      DELETE_TITLE: 'Thông báo',
      INPUT_TEXT: 'Nhập',
      EXPORT_EXCEL_ERR: 'Lỗi xuất excel. Liên hệ quản trị để xử lý.',
      DOWNLOAD_TEMPLATE_ERR: 'Không tải được file mẫu.',
      NOT_DATA: 'Không có bản ghi nào.',
      DELETE_POPUP_LOADDING: 'Bản ghi đang được xóa.',
      TEXT_MINLENGTH: 'giới hạn',
      HIDDEN_FILLTER: 'Ẩn lọc',
      FILE_NOT_CORRECT_FORMAT: 'File không đúng định dạng',
      DELETE_PERMISSION: 'Xóa phân quyền',
      CHOOSE_TIMERANGE: 'Chọn khoảng thời gian'
    },
    REPORT_MANAGEMENT: {
      FOLDER_REPORT: {
        NAME: 'Thư mục báo cáo',
        CHILD: 'thư mục báo cáo con',
        LIST: 'DANH SÁCH THƯ MỤC BÁO CÁO',
        ORDER_FOLDER_REPORT: 'Chỉnh sửa vị trí thư mục báo cáo',
        SEARCH: {
          TITLE: 'Nhập tên thư mục'
        },
        NEW: 'Thêm mới',
        DELETE_SIMPLE: {
          TITLE: 'Xóa thư mục báo cáo',
          DESCRIPTION: 'Bạn có thực sự muốn xóa?',
          WAIT_DESCRIPTION: 'Thư mục báo cáo đang xóa...',
          MESSAGE: 'Thư mục báo cáo đã được xóa'
        },
        DELETE_MULTY: {
          TITLE: 'Xóa thư mục báo cáo',
          DESCRIPTION: 'Bạn có thực sự muốn xóa?',
          WAIT_DESCRIPTION: 'Thư mục báo cáo đang xóa...',
          MESSAGE: 'Thư mục báo cáo đã được xóa'
        },
        MODEL: {
          nameFolder: 'Tên thư mục báo cáo',
          nameFolderChild: 'Tên thư mục báo cáo con',
          directory: 'Thư mục',
          description: 'Mô tả',
          directoryNumber: 'Số thư mục',
          parentId: 'Thư mục báo cáo cha',
          roleAccess: 'Quyền truy cập',
          status: 'Trạng thái'
        },
        PLACE_HOLDER: {
          NAME: 'Nhập tên thư mục',
          DESCRIPTION: 'Nhập mô tả',
          PARENTS: 'Chọn thư mục cha',
          DELETE_PERMISSION: 'Xóa phân quyền',
          NAME_FOLDER: 'Nhập tên thư mục báo cáo'
        },
        VALIDATION: {
          nameFolder: 'Tên thư mục báo cáo bắt buộc',
        }
      },
      REPORT: {
        REPORT: 'Báo cáo',
        REPORT_LIST: 'DANH SÁCH BÁO CÁO',
        NEW_REPORT: 'Thêm mới',
        SEARCH: {
          TITLE: 'Nhập tên báo cáo'
        },
        BUTTON_TITLE: {
          EDIT: 'Chỉnh sửa báo cáo',
          DOWNLOAD: 'Tải báo cáo',
          DELETE: 'Xóa báo cáo'
        },
        DELETE_REPORT_SIMPLE: {
          TITLE: 'Xóa báo cáo',
          DESCRIPTION: 'Bạn có thực sự muốn xóa?',
          WAIT_DESCRIPTION: 'Báo cáo đang xóa...',
          MESSAGE: 'Báo cáo đã được xóa'
        },
        DELETE_REPORT_MULTY: {
          TITLE: 'Xóa báo cáo',
          DESCRIPTION: 'Bạn có thực sự muốn xóa?',
          WAIT_DESCRIPTION: 'Báo cáo đang xóa...',
          MESSAGE: 'Báo cáo đã được xóa'
        },
        UPDATE_STATUS: {
          TITLE: 'Trạng thái đã được cập nhật',
          MESSAGE: 'Trạng thái đã được cập nhật thành công'
        },
        EDIT: {
          UPDATE_MESSAGE: 'Báo cáo đã được cập nhật',
          ADD_MESSAGE: 'Báo cáo đã được tạo'
        },
        FILTER_STATUS: {
          TITLE: 'Lọc theo trạng thái',
          ACTIVE: 'Hiển thị',
          INACTIVE: 'Không hiển thị'
        },
        MODEL: {
          ID: 'Id',
          CODE: 'Mã báo cáo',
          NAME: 'Tên báo cáo',
          DESCRIPTION: 'Mô tả',
          STATUS: 'Trạng thái',
          FOLDER: 'Thư mục',
          ACTION: 'Thao tác',
          FILE: 'File đính kèm',
          PARENT: 'Báo cáo cha'
        },
        PLACE_HOLDER: {
          CODE: 'Nhập mã báo cáo',
          NAME: 'Nhập tên báo cáo',
          FOLDER: 'Chọn thư mục',
          FOLDER_NAME: 'Nhập tên thư mục',
          FILE: 'Tải lên báo cáo',
          DESCRIPTION: 'Nhập mô tả',
          PARENT: 'Chọn báo cáo cha',
          PARENT_NAME: 'Nhập tên báo cáo cha'
        },
        VALIDATION: {
          CODE_REQUIRED: 'Mã báo cáo bắt buộc',
          CODE_ALLOW: 'Mã báo cáo hợp lệ',
          CODE_MINLENGTH: 'Mã báo cáo tối thiểu  ',
          CODE_MAXLENGTH: 'Mã báo cáo giới hạn ',
          NAME_REQUIRED: 'Tên báo cáo bắt buộc',
          NAME_ALLOW: 'Tên báo cáo hợp lệ',
          NAME_MINLENGTH: 'Tên báo cáo tối thiểu ',
          NAME_MAXLENGTH: 'Tên báo cáo giới hạn ',
          DESCRIPTION_MINLENGTH: 'Mô tả tối thiểu ',
          DESCRIPTION_MAXLENGTH: 'Mô tả giới hạn ',
          FOLDER_REQUIRED: 'Thư mục bắt buộc',
          FOLDER_ALLOW: 'Chọn thư mục hợp lệ',
          PARENT_ALLOW: 'Chọn báo cáo hợp lệ',
        }
      },
      REPORT_PERMISSION: {
        REPORT_PERMISSION: 'Phân quyền báo cáo',
        REPORT_PERMISSION_LIST: 'DANH SÁCH PHÂN QUYỀN BÁO CÁO',
        SEARCH: {
          TITLE: 'Nhập vai trò, người dùng'
        },
        UPDATE_STATUS: {
          TITLE: 'Trạng thái đã được cập nhật',
          MESSAGE: 'Trạng thái đã được cập nhật thành công'
        },
        DELETE_REPORT_PERMISSION_SIMPLE: {
          TITLE: 'Xóa phân quyền báo cáo',
          DESCRIPTION: 'Bạn có thực sự muốn xóa?',
          WAIT_DESCRIPTION: 'Phân quyền báo cáo đang xóa...',
          MESSAGE: 'Phân quyền báo cáo đã được xóa'
        },
        DELETE_REPORT_PERMISSION_MULTY: {
          TITLE: 'Xóa phân quyền báo cáo',
          DESCRIPTION: 'Bạn có thực sự muốn xóa?',
          WAIT_DESCRIPTION: 'Phân quyền báo cáo đang xóa...',
          MESSAGE: 'Phân quyền báo cáo đã được xóa'
        },
        ASSIGN: {
          ASSIGN_MESSAGE: 'Phân quyền báo cáo thành công'
        },
        FILTER_STATUS: {
          TITLE: 'Lọc theo trạng thái',
          ACTIVE: 'Hiển thị',
          INACTIVE: 'Ngừng hiển thị'
        },
        MODEL: {
          ID: 'Id',
          ROLE_NAME: 'Vai trò',
          USER_NAME: 'Người dùng',
          REPORT_NAME: 'Tên báo cáo',
          READ: 'Xem',
          SHARE: 'Chia sẻ',
          STATUS: 'Trạng thái',
          ACTION: 'Thao tác'
        },
        VALIDATION: {
          ROLE_ALLOW: 'Chọn vai trò hợp lệ',
          ROLE_REQUIRED: 'Vai trò bắt buộc'
        },
        MODAL: {
          TITLE: 'Danh sách vai trò được phân quyền vào báo cáo',
        }
      },
      FOLDER_REPORT_PERMISSION: {
        FOLDER_REPORT_PERMISSION: 'Phân quyền thư mục báo cáo',
        FOLDER_REPORT_PERMISSION_LIST: 'DANH SÁCH PHÂN QUYỀN THƯ MỤC BÁO CÁO',
        UPDATE_STATUS: {
          TITLE: 'Trạng thái đã được cập nhật',
          MESSAGE: 'Trạng thái đã được cập nhật thành công'
        },
        ASSIGN: {
          ASSIGN_MESSAGE: 'Phân quyền thư mục báo cáo thành công'
        },
        FILTER_STATUS: {
          TITLE: 'Lọc theo trạng thái',
          ACTIVE: 'Hiển thị',
          INACTIVE: 'Không hiển thị'
        },
        DELETE_FOLDER_REPORT_PERMISSION_SIMPLE: {
          TITLE: 'Xóa phân quyền thư mục báo cáo',
          DESCRIPTION: 'Bạn có thực sự muốn xóa?',
          WAIT_DESCRIPTION: 'Phân quyền thư mục báo cáo đang xóa...',
          MESSAGE: 'Phân quyền thư mục báo cáo đã được xóa'
        },
        DELETE_FOLDER_REPORT_PERMISSION_MULTY: {
          TITLE: 'Xóa phân quyền thư mục báo cáo',
          DESCRIPTION: 'Bạn có thực sự muốn xóa?',
          WAIT_DESCRIPTION: 'Phân quyền thư mục báo cáo đang xóa...',
          MESSAGE: 'Phân quyền thư mục báo cáo đã được xóa'
        },
        MODEL: {
          ID: 'Id',
          ROLE_NAME: 'Vai trò',
          USER_NAME: 'Người dùng',
          FOLDER_NAME: 'Tên thư mục',
          STATUS: 'Trạng thái',
          ACTION: 'Thao tác',
          WRITE: 'Thêm',
          UPDATE: 'Sửa'
        },
        VALIDATION: {

        },
        MODAL: {
          TITLE: 'Danh sách vai trò được phân quyền vào thư mục báo cáo'
        }
      }
    },
    ADMINISTRATION: {
      USER_MANAGEMENT: {
        MODEL: {
          CODE: 'Mã cán bộ',
          NAME: 'Tên cán bộ',
          PHONE: 'Số điện thoại',
          EMAIL: 'Email',
          POSITION: 'Chức vụ',
          UNIT: 'Đơn vị',
          GENDER: 'Giới tính',
          DK: 'Đính kèm',
          BIRTHDAY: 'Ngày tháng năm sinh',
          ADDRESS: 'Địa chỉ nhà',
          FULL_NAME: 'Họ và tên',
          ROLE: 'Vai trò',
          USERNAME: 'Username'
        },
        COMMON: {
          KEY_BUTTON: 'người dùng',
          TITLE: 'Quản lý người dùng',
          ADD_NEW_TITLE: 'Thêm mới người dùng',
          EDIT_TITLE: 'Chỉnh sửa người dùng',
          TITLE_INFO: 'Thông tin cá nhân'
        },
        PLACEHOLDER: {
          INPUT_SEARCH: 'Nhập mã cán bộ, họ và tên',
          INPUT_NAME: 'Nhập tên cán bộ',
          INPUT_CODE: 'Nhập mã cán bộ',
          INPUT_PHONE: 'Nhập số điện thoại',
          INPUT_EMAIL: 'Nhập email',
          SELECT_POSITION: 'Chọn chức vụ',
          SELECT_UNIT: 'Chọn đơn vị',
          SELECT_GENDER: 'Chọn giới tính',
          SELECT_BIRTHDAY: 'Chọn ngày sinh',
          INPUT_ADDRESS: 'Nhập địa chỉ nhà',
          INPUT_DK: 'Tải ảnh lên',
          INPUT_ROLL: 'Nhập vai trò',
          ROLL_NULL: 'Chưa có vai trò',
          INPUT_ROLL2: 'Chọn vai trò',
        }
      }
    },
  }
};
